const commentStringTypes = ['New workflow status: pass.', 'New workflow status: failed.'];

export default commentStringTypes;
